<template>
    <div
        :style="{padding: padding}"
        class="center"
    >
        <slot/>
    </div>
</template>

<script>
export default {
    name: 'CenterContent',
    props: {
        padding: {
            type: String,
            default: '0',
        },
    },
};
</script>

<style lang="scss" scoped>
.center {
    width: 1200px;
    margin: 0 auto;
    @media screen and (max-width: 1200px) {
        width: 100%;
    }
}
</style>
